// src/pages/Technology.js
// Technology stack grouped by layer, with a "how it fits together" narrative.
import React from 'react';
import { useTranslation } from 'react-i18next';
import PageMeta from '../components/SEO/PageMeta';
import StructuredData from '../components/SEO/StructuredData';
import CtaBanner from '../components/CtaBanner';

const Technology = () => {
    const { t } = useTranslation();
    const groups = t('technology_page.groups', { returnObjects: true }) || [];

    return (
        <>
            <PageMeta
                title={t('technology_page.meta_title')}
                description={t('technology_page.meta_description')}
                path="/technology"
            />
            <StructuredData type="page" page={{ name: t('nav.technology'), path: '/technology', description: t('technology_page.meta_description') }} />

            {/* Page header */}
            <div className="bg-slate-900 py-16">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-aos="fade-up">
                    <h1 className="text-4xl font-bold text-white mb-4">{t('technology_page.title')}</h1>
                    <p className="text-lg text-gray-300 max-w-3xl mx-auto">{t('technology_page.subtitle')}</p>
                </div>
            </div>

            <div className="bg-gray-100 py-12">
                <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
                    <p className="text-gray-700 text-lg max-w-4xl mx-auto text-justify mb-12" data-aos="fade-up">
                        {t('technology_page.intro')}
                    </p>

                    <div className="space-y-8">
                        {Array.isArray(groups) && groups.map((group, gi) => (
                            <div key={gi} className="bg-white rounded-xl shadow-lg p-6" data-aos="fade-up" data-aos-delay={gi * 100}>
                                <h2 className="text-2xl font-bold text-primary mb-1">{group.title}</h2>
                                <p className="text-gray-500 mb-5">{group.desc}</p>
                                <div className="grid md:grid-cols-2 gap-4">
                                    {Array.isArray(group.items) && group.items.map((item, ii) => (
                                        <div key={ii} className="border border-gray-200 rounded-lg p-4 hover:border-primary transition-colors">
                                            <h3 className="font-bold text-gray-800 mb-1">{item.name}</h3>
                                            <p className="text-sm text-gray-600 text-justify">{item.desc}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* How it fits together */}
                    <div className="bg-slate-900 rounded-xl shadow-lg p-8 mt-12" data-aos="fade-up">
                        <h2 className="text-2xl font-bold text-white mb-4">{t('technology_page.together_title')}</h2>
                        <p className="text-gray-300 text-lg text-justify">{t("technology_page.together_text")}</p>
                    </div>
                </div>
            </div>

            <CtaBanner
                title={t('solutions_common.cta_title')}
                text={t('solutions_common.cta_text')}
                buttonLabel={t('solutions_common.cta_button')}
            />
        </>
    );
};

export default Technology;
